var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.083 11.747 3.045-3.045-.878-.878-1.542 1.541V5.657h-1.25v3.708L4.917 7.824l-.878.878zM1.25 3.67v8.99a.25.25 0 0 0 .072.185.25.25 0 0 0 .184.072H12.66a.25.25 0 0 0 .185-.072.25.25 0 0 0 .072-.185V3.67zm.32 10.497q-.622 0-1.096-.474T0 12.596V2.921q0-.267.086-.51t.257-.448L1.513.548q.205-.267.513-.408t.65-.14h8.798q.343 0 .655.14t.517.408l1.178 1.431q.171.206.257.452t.086.515v9.65q0 .624-.474 1.097-.474.474-1.097.474zM1.576 2.42h11.008l-.908-1.082a.3.3 0 0 0-.093-.064.3.3 0 0 0-.108-.024h-8.79a.3.3 0 0 0-.108.024.3.3 0 0 0-.092.064z"
  })));
};
export default SvgArchive;